<template>
  <v-card>
    <v-card-title>{{ category.name }}</v-card-title>
    <v-card-text
      >Number of Products: {{ category.productsPaths.length }}</v-card-text
    >
  </v-card>
</template>

<script setup lang="ts">
  import ICategory from '@/interfaces/ICategory';
  defineProps({
    category: {
      type: Object as () => ICategory,
      required: true,
    },
  });
</script>
